import { reactive } from "vue";
import { ClienteLoginResult } from "@/services/clienteService";


interface IControleStore {
  token: string,
  usuario?: ClienteLoginResult | null
}

const stateControle: IControleStore = reactive({
  token: "",
  usuario: null
});


export default stateControle;
